import {Karen} from "../Karen";
import {TimelineLite} from "gsap";
import {KarenLayers, Layers} from "./KarenLayers";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {KarenSymbol} from "../symbol/KarenSymbol";
import {KarenGameConfig} from "../KarenGameConfig";
import {KarenReelView} from "../reels/KarenReelView";
import {KarenSoundManager} from "../sound/KarenSoundManager";
import {KarenSoundConfig} from "../sound/KarenSoundConfig";


export class ScatterAnimation extends PIXI.Container {
    private _scatterAnimation: PIXI.spine.Spine | null;
    private _stagePosition: number[] = [0, 0];

    constructor(jsonName: string) {
        super();
        this._scatterAnimation = new PIXI.spine.Spine(Karen.assetLoader.getSpineAsset(jsonName));
        this._scatterAnimation.autoUpdate = true;
        this._scatterAnimation.visible = false;
    }

    public setStagePosition(stagePosition: PIXI.Point): void {
        this._stagePosition[0] = stagePosition.x;
        this._stagePosition[1] = stagePosition.y - 18;
        this._scatterAnimation!.position.set(stagePosition.x, stagePosition.y - 18);
    }

    public stopScatterWin(): void {
        let length: number = KarenLayers.getLayer(Layers.SCATTER_OVERLAY)!.children.length;
        for (let count: number = 0; count < length; count++) {
            let scatterAnim: PIXI.spine.Spine = KarenLayers.getLayer(Layers.SCATTER_OVERLAY)!.children[0] as PIXI.spine.Spine;
            //with each looping step first element is removed and secnd is pushed to index 0
            if (scatterAnim) {
                scatterAnim.state.setEmptyAnimation(0, 0);
                scatterAnim.visible = false;
                scatterAnim.destroy();
                KarenLayers.getLayer(Layers.SCATTER_OVERLAY)!.removeChild(scatterAnim);
                this._scatterAnimation = null;
            }
        }
    }
    public removeScatter(): void {
        let length: number = KarenLayers.getLayer(Layers.SCATTER_BELOW)!.children.length;
        for (let count: number = 0; count < length; count++) {
            let scatterAnim: PIXI.spine.Spine = KarenLayers.getLayer(Layers.SCATTER_BELOW)!.children[0] as PIXI.spine.Spine;
            //with each looping step first element is removed and secnd is pushed to index 0
            if (scatterAnim) {
                scatterAnim.state.setEmptyAnimation(0, 0);
                scatterAnim.visible = false;
                scatterAnim.destroy();
                KarenLayers.getLayer(Layers.SCATTER_BELOW)!.removeChild(scatterAnim);
                this._scatterAnimation = null;
            }
        }
    }

    /*played for Landing Animation
    * and Trigger Animation
    * */
    public playScatterAnimation(animName: string, reelId: number, symId: number): TimelineLite {
        const evaluatedSize: number = Karen.model.parsedGameData.evaluatedArea[reelId].length;
        const playTL: TimelineLite = new TimelineLite();
        if (this._scatterAnimation) {
            playTL.add(() => {
                const symbol: KarenSymbol = Karen.reels[reelId].getSymbol(symId);
                const stagePos: PIXI.Point = symbol.getStagePosition();
                KarenLayers.getLayer(Layers.SCATTER_OVERLAY)!.addChild(this._scatterAnimation!);
                this._scatterAnimation!.visible = true;
                this._scatterAnimation!.alpha = 1;
                const reelY: number = KarenReelView.reelPosHeight[evaluatedSize];
                const sPosY: number = reelY + (symId * KarenGameConfig.SYM_HEIGHT[reelId] + 42);
                this._scatterAnimation!.position.set(stagePos.x, sPosY);
            }, 0);
            playTL.add(new SpineTween(this._scatterAnimation, 0, animName));
        }
        return playTL;
    }

    /*played fr StoX Conversion
    * */
    public playFinalAnimation(animName: string, abort: boolean = false, duration: number = 1): TimelineLite {
        const playTL: TimelineLite = new TimelineLite({
            onComplete: () => {
                this.stopScatterWin();
            }
        });
        (<PIXI.spine.Spine[]>KarenLayers.getLayer(Layers.SCATTER_OVERLAY)!.children).forEach((scatterAnim: PIXI.spine.Spine) => {
            if (scatterAnim) {
                duration = abort ? 0.2 : duration;
                playTL.add(() => {
                    scatterAnim!.state.setAnimation(0, animName, false);
                    scatterAnim!.state.timeScale = this.getAnimDuration(animName) / duration;
                    const trackEntry: PIXI.spine.core.TrackEntry = scatterAnim!.state.getCurrent(0);
                    abort && (trackEntry.trackTime = trackEntry.animation.duration);
                }, 0.01);
                playTL.add(() => {
                }, duration);
            }
        });
        return playTL;
    }
    public playTriggerAnimation(animName: string, abort: boolean = false, duration: number = 1): TimelineLite {
        const playTL: TimelineLite = new TimelineLite({
            onComplete: () => {
               // this.stopScatterWin();

            }
        });

        (<PIXI.spine.Spine[]>KarenLayers.getLayer(Layers.SCATTER_OVERLAY)!.children).forEach((scatterAnim: PIXI.spine.Spine) => {
            if (scatterAnim) {
                duration = abort ? 0.2 : duration;
                playTL.add(() => {
                    scatterAnim!.state.setAnimation(0, animName, false);
                    scatterAnim!.state.timeScale = this.getAnimDuration(animName) / duration;
                    const trackEntry: PIXI.spine.core.TrackEntry = scatterAnim!.state.getCurrent(0);
                    abort && (trackEntry.trackTime = trackEntry.animation.duration);
                }, 0.01);
                playTL.add(() => {
                }, duration);
            }
        });
        return playTL;
    }
    public playTurnToBurgerAnimation(animName: string="turn_to_burger", abort: boolean = false, duration: number = 1): TimelineLite {
        const playTL: TimelineLite = new TimelineLite({
            onComplete: () => {
                this.removeScatter();
            }
        });
        let length: number = KarenLayers.getLayer(Layers.SCATTER_OVERLAY)!.children.length;
        for (let count: number = 0; count < length; count++) {
            let scatterAnim: PIXI.spine.Spine = KarenLayers.getLayer(Layers.SCATTER_OVERLAY)!.children[0] as PIXI.spine.Spine;
            KarenLayers.getLayer(Layers.SCATTER_BELOW)!.addChild(scatterAnim);
        }
        (<PIXI.spine.Spine[]>KarenLayers.getLayer(Layers.SCATTER_BELOW)!.children).forEach((scatterAnim: PIXI.spine.Spine) => {
            if (scatterAnim) {
                duration = abort ? 0.2 : duration;
                playTL.add(() => {
                    scatterAnim!.state.setAnimation(0, animName, false);
                    //scatterAnim!.state.timeScale = this.getAnimDuration(animName) / duration;
                    const trackEntry: PIXI.spine.core.TrackEntry = scatterAnim!.state.getCurrent(0);
                    abort && (trackEntry.trackTime = trackEntry.animation.duration);
                }, 0.01);
                playTL.add(() => {
                }, duration);
            }
        });
        return playTL;
    }

    public getAnimDuration(animName: string): number {
        return this._scatterAnimation!.spineData.findAnimation(animName).duration;
    }

}
